/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum AuditType {
  ORDER_CREATED = 'order_created',
  ORDER_UPDATED = 'order_updated',
  ORDER_DELETED = 'order_deleted',
  ORDER_RESTORED = 'order_restored',
  PENDING_ORDER_CONFIRMED = 'pending_order_confirmed',
  PENDING_ORDER_REJECTED = 'pending_order_rejected',
  EVENT_CREATED = 'event_created',
  EVENT_UPDATED = 'event_updated',
  EVENT_DELETED = 'event_deleted',
  ORDER_CONVERTED_TO_VOUCHER = 'order_converted_to_voucher',
  VOUCHER_CREATED_FROM_ORDER = 'voucher_created_from_order',
  VOUCHER_CONVERTED_TO_ORDER = 'voucher_converted_to_order',
  ORDER_CREATED_FROM_VOUCHER = 'order_created_from_voucher',
  PAYMENT_LINK_CREATED = 'payment_link_created',
  PAYMENT_LINK_PAID = 'payment_link_paid',
  COURSE_ORDER_CREATED = 'course_order_created',
  COURSE_ORDER_PAID = 'course_order_paid',
  COURSE_ORDER_DELETED = 'course_order_deleted',
  ORDER_CREATED_FROM_PASS = 'order_created_from_pass',
  PASS_CREATED = 'pass_created',
  PASS_UPDATED = 'pass_updated',
  PASS_PAUSED = 'pass_paused',
  PASS_RESUMED = 'pass_resumed',
  PASS_ARCHIVED = 'pass_archived',
  PASS_RENEWED = 'pass_renewed',
  PASS_RENEWAL_FAILED = 'pass_renewal_failed',
  PASS_SUBSCRIPTION_CANCELED = 'pass_subscription_canceled',
  PASS_SUBSCRIPTION_REACTIVATED = 'pass_subscription_reactivated',
  PASS_PUNCH_CANCELED = 'pass_punch_canceled',
  PASS_PUNCH_RESTORED = 'pass_punch_restored',
  PASS_GUEST_PUNCH_CONSUMED = 'pass_guest_punch_consumed',
  PASS_GUEST_PUNCH_RESTORED = 'pass_guest_punch_restored',
  PASS_SWAPPED = 'pass_swapped',
  PASS_SWAP_SCHEDULED = 'pass_swap_scheduled',
  PASS_SWAP_CANCELED = 'pass_swap_canceled',
  PASS_SCHEDULE_RELEASED = 'pass_schedule_released',
  PASS_PUNCHES_ADJUSTED = 'pass_punches_adjusted',
  CHECKIN_CREATED = 'checkin_created',
  CHECKIN_UPDATED = 'checkin_updated',
  EXTERNAL_VOUCHER_VERIFIED = 'external_voucher_verified',
  EXTERNAL_VOUCHER_REJECTED = 'external_voucher_rejected',
  PROJECT_SELECTION_UPDATED = 'project_selection_updated',
  EXTRA_PAYMENT_UPDATED = 'extra_payment_updated',
  EXTRA_PAYMENT_DELETED = 'extra_payment_deleted',
  REFUND_SUCCEEDED = 'refund_succeeded',
  REFUND_PENDING = 'refund_pending',
  REFUND_FAILED = 'refund_failed',
  REFUND_BLOCKED = 'refund_blocked',
  USER_CREATED = 'user_created',
  USER_UPDATED = 'user_updated',
  USER_ROLE_CHANGED = 'user_role_changed',
  USER_BLOCKED = 'user_blocked',
  USER_UNBLOCKED = 'user_unblocked',
  USER_PASSWORD_RESET = 'user_password_reset',
  ORDER_PAGE_UPDATED = 'order_page_updated',
  ORDER_PAGE_ARCHIVED = 'order_page_archived',
  ORDER_PAGE_RESTORED = 'order_page_restored',
  PASS_ORDER_PAGE_UPDATED = 'pass_order_page_updated',
  PASS_ORDER_PAGE_ARCHIVED = 'pass_order_page_archived',
}
